<div class="main-wrapper-section">
    <div class="common-layout-section">
        <div class="common-header">
            <h3 style="flex: 1; margin-bottom: 0px;">Triggers</h3>
            <select class="form-control margin-left15" *ngIf="isShowClone" (change)="onChangeCloneOpt($event)" style="width:auto">
                <option selected="selected" value="">-Select Action-</option>
                <option value="-1" *ngFor="let item of cloneOpts" [value]="item?.value">{{item?.display}}</option>
            </select>
            <button class="btn primary-btn margin-left15" *ngIf="!isShowClone && cloneOpts?.length > 1" (click)="showCloneDD()">Clone</button>
        </div>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="field-form-panel">
                <div class="flex-form">
                    <div class="form-group">
                        <label>Contract Sent (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="contractSent"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Contract Opened (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="contractOpen"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Contract Waiting Countersign (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="waitingCountersign"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                </div>
                <div class="flex-form">
                    <div class="form-group">
                        <label>Contract Active -New Member - (web form)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="webFormList"
                                        [valuePrimitive]="true"
                                        textField="value"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="newMemberId"
                                        valueField="key">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Contract Expiration (web form)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="webFormList"
                                        [valuePrimitive]="true"
                                        textField="value"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="contractExpired"
                                        valueField="key">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Co-Member Added (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="memberAdded"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                </div>
                <div class="flex-form">
                    <div class="form-group">
                        <label>Contract Upgraded (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="contractUpgraded"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Contract Renewed (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="contractRenewed"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Member Terminated (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="memberTerminated"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                </div>
                <hr />
                <div class="flex-form">
                    <div class="form-group">
                        <label>New Lead (web form)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="webFormList"
                                        [valuePrimitive]="true"
                                        textField="value"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="newLeadId"
                                        valueField="key">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Contact Update (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="contactUpdateId"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                    <div class="form-group">
                        <label>Referral Request (automation)</label>
                        <kendo-combobox class="form-control min-width300"
                                        [data]="automationProcessList"
                                        [valuePrimitive]="true"
                                        textField="campaignTemplateName"
                                        [kendoDropDownFilter]="filterSettings"
                                        [filterable]="true"
                                        [ngModelOptions]="{standalone: true}"
                                        [(ngModel)]="referralRequest"
                                        valueField="campaignTemplateID">
                        </kendo-combobox>
                    </div>
                </div>
            </div>
            <hr />
            <div class="flex-form">
                <div class="form-group">
                    <label class="checkbox-inline">
                        <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="enableAutomationAlert" />
                        Enable automation alert emails for this site
                    </label>
                    <small class="d-block text-muted">When unchecked, this site will not send "Site Settings weren't set" admin alert emails. Leave checked for sites that should have automation triggers configured.</small>
                </div>
            </div>
            <div class="button-group">
                <div class="form-group">
                    <button class="primary-btn" (click)="triggerSaved()">Save<i *ngIf="submitted" class="fas fa-spinner fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</div>
<!--<div class="loader-body" *ngIf="showSpinner">
  <div class="lds-ripple"><div></div><div></div></div>
</div>-->
